'use strict';

module.exports = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/PROPERTY_RANGE_REG.js
// module id = 1157
// module chunks = 0